var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{staticClass:"pt-10"},[_c('search-bar'),_c('movie-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }